<p>login-as works!</p>
